import { AppNav } from './AppNav';

export const AppLayout = ({ children }) => (

    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>

        <AppNav />

        <main style={{ display: 'flex', flex: 1, flexDirection: 'column', minHeight: 0 }}>
            {children}
        </main>

    </div>

);
